import { render, staticRenderFns } from "./DayOpeningHours.vue?vue&type=template&id=2aaa6e66&"
import script from "./DayOpeningHours.vue?vue&type=script&lang=js&"
export * from "./DayOpeningHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports